import { createSlice } from '@reduxjs/toolkit';
import offers from '../../mocks/offers';
import { OffersState } from './types';

const initialState: OffersState = {
  data: offers,
};

// Create Slice
const offersSlice = createSlice({
  name: 'offers',
  initialState,
  reducers: {},
});

export default offersSlice.reducer;
